import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, of, Subject} from 'rxjs';
import {catchError, filter, map, switchMap, tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import {LocalStorageService} from "../services/local-storage-service.service";


@Injectable({
  providedIn: 'root'
})
export class UserService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #router: Router = inject(Router);
  readonly #storage: LocalStorageService = inject(LocalStorageService);

  private readonly user: BehaviorSubject<any> = new BehaviorSubject<any>(this.#storage.get('user') ?? null);
  public readonly user$: Observable<any> = this.user.asObservable()
    .pipe(tap((user) => this.#storage.set('user', user)));
  private readonly userRequest: Subject<void> = new Subject<void>();

  constructor() {
    this.subscribeEmitters();
  }

  public getUserRoles(): string[] {
    return this.user.getValue().roles as string[];
  }

  public requestUserProfile(): void {
    this.userRequest.next();
  }

  public clearUserProfile(): void {
    this.user.next(null);
    this.#storage.remove('user');
    void this.#router.navigate(['/login']);
  }

  public requestProfile(): Observable<any> {
    return this.#http.get<any>(`${environment.apiUrl}/users/me`, {withCredentials: true})
      .pipe(catchError((error: HttpErrorResponse) => of(null)));
  }

  public requestRoles(): Observable<any> {
    return this.#http.get<any>(`${environment.apiUrl}/users/roles`, {withCredentials: true})
      .pipe(catchError((error: HttpErrorResponse) => of([])));
  }

  private subscribeEmitters(): void {

    this.userRequest
      .pipe(
        switchMap(() => combineLatest([this.requestProfile(), this.requestRoles()])),
        filter(([user, role]) => !!user && !!role),
        map(([user, roles]) => ({...user, roles})))
      .subscribe((user: any) => {
        this.user.next(user);
        const url = this.#router.routerState.snapshot.url;
        if (url === '/login') {
          void this.#router.navigate(['/']);
        }
      });
  }
}
